import { format } from "date-fns";
import { inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Container, MagicLink } from "../../ui";
import { PageBlockInterface } from "../Block.component";
import type { ApplicationNoticesFragment } from "@ihr-radioedit/inferno-webapi";
import type { Store } from "@inferno/renderer-shared-core";

interface ApplicationNoticeProps extends PageBlockInterface {
  store?: Store;
}

export const FccApplication = inject("store")(({ store }: ApplicationNoticeProps) => {
  if (!store) {
    return null;
  }
  const { t } = useTranslation();
  const { site } = store;
  const applicationNoticesList: ApplicationNoticesFragment[] = [];
  site.integration?.plugin?.broadcastFacilities?.forEach(element => {
    element.applicationNotices.forEach(sub => {
      applicationNoticesList.push(sub);
    });
  });

  const haveFacilityApplicationLinks = applicationNoticesList?.map(v => !!v.text).reduce((a, b) => !!a || !!b, false);

  const updated = (
    <p>
      {t("Updated")}: {format(Date.now(), "MM/dd/yyyy")}
    </p>
  );

  return (
    <Container>
      {haveFacilityApplicationLinks ? (
        applicationNoticesList?.map(({ link, text }, i) =>
          text ? (
            <p key={i}>
              {text}
              {link ? (
                <>
                  {": "}
                  <MagicLink to={link} target="_blank">
                    {t("here")}
                  </MagicLink>
                </>
              ) : null}
            </p>
          ) : null,
        )
      ) : (
        <p>{t("no_pending_applications")}</p>
      )}
      {updated}
    </Container>
  );
});

export default FccApplication;
